import { Alert, Table } from "flowbite-react";
import TitleStripe from "../TitleStripe";
import NoOcurrence from "./NoOcurrence";
import { formatToReal } from "../../../utils/utils";

const rating = {
  A: "CNPJ com Alta atividade reportada nos últimos 6 meses em comparação ao mercado",
  M: "CNPJ com Média atividade reportada nos últimos 6 meses em comparação ao mercado",
  B: "	CNPJ com Baixa Atividade reportada nos últimos 6 meses em comparação ao mercado",
  0.1: "CNPJ MEI sem Atividade nos últimos 6 meses. Sócio PF apresenta movimentação no mercado de crédito no período",
  0.2: "CNPJ MEI sem atividade reportada nos últimos 6 meses em PJ e PF relacionado",
  0.3: "CNPJ não-MEI sem atividade reportada nos últimos 6 meses",
};

const GrauAtividade = ({ data }) => {
  return (
    <>
      <TitleStripe>Grau de atividade</TitleStripe>
      {!data?.ErrorMessage ? (
        <>
          <div className="grid grid-cols-2 gap-2">
            <div className="flex items-center gap-2">
              <div className="font-semibold">Score de atividade:</div>
              <div className="capitalize">{data?.ActivityScore}</div>
            </div>
            <div className="flex items-center gap-2">
              <div className="font-semibold">Índice de confiança:</div>
              <div>{data?.Rating}</div>
            </div>
          </div>
          <div>Descrição: {rating[data?.Rating]}</div>
        </>
      ) : (
        <Alert className="mt-1" withBorderAccent>
          {data?.ErrorMessage}
        </Alert>
      )}
    </>
  );
};

export default GrauAtividade;
